var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsrit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 44,
    viewBox: "0 0 132 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 44,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 40,
    width: 4,
    height: 4,
    fill: "#898987"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8496 31H23.2832V13H27.1328V15.5752H28.4248V19.4336H29.708V23.292H30.9912V27.1504H32.2832V23.292H33.5664V19.4336H34.8496V15.5752H36.1328V13H39.9912V31H37.4248V19.4336H36.1328V23.292H34.8496V27.1504H33.5664V31H29.708V27.1504H28.4248V23.292H27.1328V19.4336H25.8496V31ZM44.3952 31H41.8288V28.4336H44.3952V31ZM57.808 31H48.808V29.7168H47.5248V28.4336H46.2416V25.8584H48.808V27.1504H50.0912V28.4336H56.5248V27.1504H57.808V24.5752H56.5248V23.292H50.0912V22H47.5248V20.7168H46.2416V15.5752H47.5248V14.292H48.808V13H57.808V14.292H59.0912V15.5752H60.3832V18.1504H57.808V16.8584H56.5248V15.5752H50.0912V16.8584H48.808V19.4336H50.0912V20.7168H56.5248V22H59.0912V23.292H60.3832V28.4336H59.0912V29.7168H57.808V31ZM64.7873 31H62.2209V28.4336H64.7873V31ZM69.2001 31H66.6337V13H78.2001V14.292H79.4833V15.5752H80.7753V21.3584H79.4833V22.6504H78.2001V23.9336H79.4833V25.2168H80.7753V31H78.2001V26.5H76.9169V25.2168H75.6337V23.9336H69.2001V31ZM69.2001 21.3584H76.9169V20.0752H78.2001V16.8584H76.9169V15.5752H69.2001V21.3584ZM85.1793 31H82.6129V28.4336H85.1793V31ZM89.5921 31H87.0257V13H89.5921V31ZM94.0049 31H91.4385V28.4336H94.0049V31ZM102.918 31H100.351V15.5752H95.2097V13H108.059V15.5752H102.918V31Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 4,
    height: 4,
    fill: "#898987"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "#898987"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 4,
    height: 4,
    fill: "#898987"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 40,
    width: 4,
    height: 4,
    fill: "#898987"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 36,
    width: 4,
    height: 4,
    fill: "#898987"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 8,
    width: 4,
    height: 4,
    fill: "#898987"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 4,
    width: 4,
    height: 4,
    fill: "#898987"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    width: 4,
    height: 4,
    fill: "#898987"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsrit);
export default __webpack_public_path__ + "static/media/MSRIT.35838f48befcf7404c866b69babe612f.svg";
export { ForwardRef as ReactComponent };